import stage from '../components/stage.js'
import Component from 'gia/Component'
import gsap from 'gsap'


class Form extends Component {

    constructor(element) {

        super(element)

        this.body = $('body')
        this.element = element


        this.ref = {
            button: ''
        }

    }

    mount() {


        $('.single_add_to_cart_button').on('click', (e) => {
            e.preventDefault();

            var $thisbutton = $(this.ref.button),
                $form = $(this.element),
                id = $thisbutton.val(),
                product_qty = $form.find('input[name=quantity]').val() || 1,
                product_id = $form.find('input[name=product_id]').val() || id,
                variation_id = $form.find('input[name=variation_id]').val() || 0;

            var data = {
                action: 'ql_woocommerce_ajax_add_to_cart',
                product_id: product_id,
                product_sku: '',
                quantity: product_qty,
                variation_id: variation_id,

            };
            $.ajax({
                type: 'post',
                url: wc_add_to_cart_params.ajax_url,
                data: data,
                beforeSend: (response) => {
                    $thisbutton.removeClass('added').addClass('loading');
                },
                complete: (response) => {
                    //console.log(response);
                    $thisbutton.addClass('added').removeClass('loading');
                },
                success: (response) => {
                    console.log(response);
                    if (response.error & response.product_url) {
                        console.log(response.product_url);
                        window.location = response.product_url;
                        return;
                    } else {
                        $(document.body).trigger('wc_fragments_loaded', [response.fragments, response.cart_hash, $thisbutton]);
                    }
                }
            });
        });


    }





    unmount() {

        console.log('unmount product');

    }


}

module.exports = Form